import { Plus, Upload, X } from "lucide-react";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";

export default function BrandCreate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const typeFromUrl = searchParams.get("Type") || "PRODUCT";

  const [isLoading, setIsLoading] = React.useState(false);
  const [imagePreview, setImagePreview] = React.useState(null);
  const [uploadedImageId, setUploadedImageId] = React.useState(null);

  const [formData, setFormData] = React.useState({
    name: "",
    Type: typeFromUrl,
    // specifications: {
    //     color: "",
    //     size: ""
    // }
  });

  function handleImageUpload(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    apiRequests
      .post("/api/file/v1/upload-admin", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const imageId = response.data.message._id;
        setUploadedImageId(imageId);
        setImagePreview(URL.createObjectURL(file));
        toast.success("Image uploaded successfully");
      })
      .catch((error) => {
        console.error("Upload error:", error);
        toast.error("Failed to upload image");
      });
  }

  function createBrand() {
    if (!uploadedImageId) {
      toast.error("Please upload an image");
      return;
    }

    if (!formData.name.trim()) {
      toast.error("Please enter Brand name");
      return;
    }

    const payload = {
      name: formData.name,
      image: uploadedImageId,
      //   Type: formData.Type,
      // specifications: {
      //     color: formData.specifications.color,
      //     size: formData.specifications.size
      // }
    };

    console.log("Sending payload:", payload);

    setIsLoading(true);
    apiRequests
      .post("/api/brand/create", payload)
      .then((response) => {
        console.log(" Brand created:", response.data);
        toast.success("Brand created successfully");
        navigate(-1);
      })
      .catch((error) => {
        console.error("Full error:", error);
        console.error("Response:", error.response);
        console.error("Status:", error.response?.status);
        console.error("Data:", error.response?.data);
        toast.error(error.response?.data?.message || "Failed to create Brand");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold">Create New Brand</h1>
          <button
            onClick={() => navigate(-1)}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block mb-2 font-medium">Brand Name *</label>
              <input
                type="text"
                required
                placeholder="enter name"
                className="w-full p-2 border rounded-lg"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </div>
          </div>

          <div className="mt-6">
            <label className="block mb-2 font-medium">Brand Image *</label>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
              {imagePreview ? (
                <div className="relative inline-block">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="max-h-48 rounded-lg"
                  />
                  <button
                    onClick={() => {
                      setImagePreview(null);
                      setUploadedImageId(null);
                    }}
                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                  >
                    <X size={16} />
                  </button>
                </div>
              ) : (
                <label className="cursor-pointer">
                  <Upload className="mx-auto mb-2 text-gray-400" size={48} />
                  <p className="text-gray-600">Click to upload image</p>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleImageUpload}
                  />
                </label>
              )}
            </div>
          </div>

          {/*<div className="mt-6">*/}
          {/*    <label className="block mb-2 font-medium">Specifications</label>*/}
          {/*    <div className="space-y-2">*/}
          {/*        <div className="flex gap-2">*/}
          {/*            <input*/}
          {/*                type="text"*/}
          {/*                placeholder="Colors (e.g: Red, Blue, Green)"*/}
          {/*                className="flex-1 p-2 border rounded-lg"*/}
          {/*                value={formData.specifications.color}*/}
          {/*                onChange={e => setFormData({*/}
          {/*                    ...formData,*/}
          {/*                    specifications: {...formData.specifications, color: e.target.value}*/}
          {/*                })}*/}
          {/*            />*/}
          {/*            <input*/}
          {/*                type="text"*/}
          {/*                placeholder="Sizes (e.g: S, M, L, XL)"*/}
          {/*                className="flex-1 p-2 border rounded-lg"*/}
          {/*                value={formData.specifications.size}*/}
          {/*                onChange={e => setFormData({*/}
          {/*                    ...formData,*/}
          {/*                    specifications: {...formData.specifications, size: e.target.value}*/}
          {/*                })}*/}
          {/*            />*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</div>*/}

          <div className="mt-8 pt-6 border-t flex justify-end gap-4">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-2 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center gap-2 disabled:opacity-50"
              onClick={createBrand}
            >
              {isLoading ? (
                <span className="animate-pulse">Creating...</span>
              ) : (
                <>
                  <Plus size={18} />
                  Create Brand
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
